//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userAssessEvalApi } from '@/api/user';
export default {
  name: 'MarkDialog',
  props: {
    config: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      rules: {
        remarks: ''
      },
      rule: {},
      dialogVisible: false,
      loading: false,
      finishRatio: 0
    };
  },
  watch: {
    config: {
      handler: function handler(nVal) {
        this.finishRatio = nVal.data.finish_ratio;
      },
      deep: true
    }
  },
  methods: {
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
    },
    handleConfirm: function handleConfirm() {
      if (this.config.data.finish_ratio === undefined) {
        this.$message.error('自评分不能为空');
      } else {
        var data = {
          assess_id: this.config.assessId,
          space_id: this.config.spaceId,
          target_id: this.config.targetId,
          finish_info: this.config.data.finish_info,
          finish_ratio: this.finishRatio
        };
        this.clientEval(data);
      }
    },
    //
    clientEval: function clientEval(data) {
      var _this = this;
      this.loading = true;
      userAssessEvalApi(data).then(function (res) {
        _this.$emit('isMark');
        _this.handleClose();
        _this.config.data.finish_ratio = _this.finishRatio;
        _this.loading = false;
      }).catch(function (error) {
        _this.loading = false;
      });
    }
  }
};